module.exports = __webpack_public_path__ + "static/OpenSans-Regular-9c6168dc311b9ec191e7f64e61bca82f.ttf";